import { FC, useEffect, useState } from 'react'
import { Tabs } from 'antd'
import style from './style.m.less'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Search, Check } from './components'
import { useTranslation } from 'react-i18next'

const { TabPane } = Tabs

const UnregisteredLayout: FC = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [currentOption, setCurrentOption] = useState(() => {
        if (localStorage.getItem('green_tools_current_option')) {
            return localStorage.getItem('green_tools_current_option')
        } else {
            localStorage.setItem('green_tools_current_option', '0')
            return '0'
        }
    })

    const tabsList = [
        { label: t('greenTools.searchGreenTools'), key: 0, content: <></> /*<Search />*/ },
        { label: t('greenTools.checkGreenTools'), key: 1, content: <></> /*<Check />*/ },
    ]

    useEffect(() => {
        if (location.state && location.state?.fromMenu) {
            setCurrentOption('0')
            localStorage.setItem('green_tools_current_option', '0')
            localStorage.removeItem('green_tools_certificate_number')
            localStorage.removeItem('green_tools_delivery_range')
            localStorage.removeItem('green_tools_tool_type')
            localStorage.removeItem('green_tools_document_number')

            navigate(location.pathname, { state: { fromMenu: false } })
        }
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const certificate = params.get('certificate_number')
        const document = params.get('document_number')

        if (certificate && document) {
            setCurrentOption('1')
            localStorage.setItem('green_tools_current_option', '1')
        }
    }, [location.search])

    return (
        <div className={style.mainWrapper}>
            <div className={style.registryInfoBlock}>
                {t('greenTools.searchLabelStart')}
                <br />
                <Link to="/register">{t('greenTools.searchLabelLink')}</Link>{' '}
                {t('greenTools.searchLabelEnd')}
            </div>
            <Tabs
                defaultActiveKey="0"
                onChange={(activeKey) => {
                    setCurrentOption(activeKey)
                    localStorage.setItem('green_tools_current_option', activeKey)
                    localStorage.removeItem('green_tools_certificate_number')
                    localStorage.removeItem('green_tools_delivery_range')
                    localStorage.removeItem('green_tools_tool_type')
                    localStorage.removeItem('green_tools_document_number')
                }}
                activeKey={currentOption}
                className={style.tabs}
            >
                {tabsList.map((item) => {
                    const { label, key, content } = item

                    return (
                        <TabPane tab={label} key={key}>
                            {content}
                        </TabPane>
                    )
                })}
            </Tabs>
            {currentOption === '0' && <Search />}
            {currentOption === '1' && <Check />}
        </div>
    )
}

export default UnregisteredLayout
